export enum PrepaymentType {
    UNKNOWN = 0,
    NO_PREPAYMENT = 1,
    UP_TO_1_PRICE = 2,
    UP_TO_2_PRICE = 3,
    UP_TO_3_PRICE = 4,
}
